import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import ProtectedRoute from './ProtectedRoute'
import Intro from '../pages/Intro/Intro'
import DebugConsole from '../components/debug/DebugConsole/DebugConsole'
import ZonesDetector from '../features/zonesDetector/ZonesDetector'
import MockLocation from '../components/MockLocation/MockLocation'

const What = () => {
  return <>WHAT</>
}

const AppRouter = () => (
  <>
    <MockLocation />

    <BrowserRouter>
      <Switch>
        <Route path="/intro/:zoneId">
          <Intro />
          <DebugConsole />
        </Route>

        <Route path="/">
          <ZonesDetector />
          <DebugConsole />
        </Route>

        <Route exact path="/what" component={What} />

        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  </>
)

export default AppRouter
